import { State } from "@/store/modules/user/index";

const setUser = (state: State, payload): void => {
  state.user = payload;
};

const setSpaceUser = (state: State, payload): void => {
  if (state.spaceUser && state.spaceUser.chimeUserArn && !payload.chimeUserArn)
    payload.chimeUserArn = state.spaceUser.chimeUserArn;

  state.spaceUser = payload;
};

const setPosition = (state: State, payload): void => {
  state.position = payload;
};

const setConfig = (state: State, payload): void => {
  state.config = payload;
};

const setConfigSilenceNotification = (state: State, payload): void => {
  state.configSilenceNotification  = payload;
};

const setGameKiller = (state: State, payload: boolean) => {
  state.isKiller = payload;
};

const setIsOnline = (state: State, payload: boolean) => {
  state.isOnline = payload;
};

export default {
  setUser,
  setSpaceUser,
  setPosition,
  setConfig,
  setConfigSilenceNotification,
  setGameKiller,
  setIsOnline,
};
